import React, { Fragment } from 'react';
import styles from './feedbackWindow.css';
import Counter from 'components/counter/Counter';
import Accept from 'assets/svg/accept.svg';
import Close from 'assets/svg/close2.svg';

/**
 *
 * @type {React.NamedExoticComponent<{readonly setSound?: *, readonly settings?: *, readonly question?: *, readonly fontFamilyH2?: *, readonly styleCanvas?: *, readonly button_style?: *, readonly contentColor?: *, readonly statisticsPopupClick?: *, readonly content?: *, readonly statistics?: *}>}
 */

const FeedbackWindow = React.memo( ( { question, statisticsPopupClick, content, contentColor, button_style = {}, statistics, fontFamilyH2, styleCanvas, setSound, settings } ) => {

    const { localization: { feedback } } = question;

    return (
        <div className={ styles.wrapper }>
            <div style={ { backgroundColor: styleCanvas } } className={ styles.canvasBefore }/>
            <div id='canvasBlock' className={ styles.canvasBlock }/>
            <div className={ styles.popup }
                 style={ { backgroundColor: contentColor.overlay, color: contentColor.dark } }>
                { Boolean( settings.show_points ) ?
                    <h2 style={ fontFamilyH2 } className={ styles.statPopupTitle }>
                        { statistics.question_statistics.answered_correctly
                            ? <Accept className={ styles.ptIcon }/>
                            :
                            !statistics.question_statistics.hasOwnProperty( 'answered_correctly' )
                            && !statistics.question_statistics.timeOut
                                ? `${ content.thanks }`
                                :
                                statistics.question_statistics.timeOut
                                    ? `${ content.time_is_out }`
                                    :
                                    <div className={ styles.ptWrap }>
                                        <div>
                                            <Close className={ styles.ptIconClose }/>
                                        </div>
                                    </div>
                        }
                    </h2> :
                    <h2 className={ styles.answerSaved }>
                        { content.calendar.answer_saved }
                    </h2>
                }
                { Boolean( settings.show_points ) &&
                <p className={ styles.statPopupText }
                   style={ {
                       color: ( ( !statistics.question_statistics.answered_correctly
                           && statistics.question_statistics.hasOwnProperty( 'answered_correctly' ) )
                           || statistics.question_statistics.timeOut )
                           && '#f5a623'
                   } }>
                    { ( settings.points_limit !== 0 ) &&
                    <Fragment>+<Counter to={ statistics.question_statistics.points_gained }/> { content.quiz.editor.pt }
                    </Fragment>
                    }
                </p>

                }
                <p className={ styles.textStyle }>{ feedback !== null && feedback.feedbackText }</p>
                <a className={ styles.linkStyle } target={ '_balnk' }
                   href={ feedback !== null && feedback.url }>{ feedback !== null && feedback.urlText }</a>
                <button
                    onMouseEnter={ setSound }
                    style={ { ...button_style } }
                    className={ styles.button }
                    onClick={ statisticsPopupClick }
                    aria-label={ content.popup.ok_aria_label }
                >
                    { content.popup.ok }
                </button>

            </div>
        </div>
    );
} );

export default FeedbackWindow;